import { render, staticRenderFns } from "./CompanySaveForm.vue?vue&type=template&id=a734a482"
import script from "./CompanySaveForm.vue?vue&type=script&lang=js"
export * from "./CompanySaveForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports